import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";

import Image from './Image';

function ActiveSelections(props){
  return (
      <div className="ActiveSelections">
          {[...Array(4)].map((e,i) => {
            return (props.activeSelections && props.activeSelections[i]) ?
              <Image key={`im_${i}`} selection={props.activeSelections[i]} /> :
              <div key={`d_${i}`} className="emptySelection" onClick={props.onActiveSelectionClick} />
          })}
      </div>
  );
}

export default observer(ActiveSelections);
